// Redux Toolkit
import { createSlice } from '@reduxjs/toolkit';
import { FirestoreAnnouncement } from '@gif/shared-global';

const initialState: FirestoreAnnouncement = {
  modals: [],
};

export const announcementModalsSlice = createSlice({
  name: 'announcementModals',
  initialState,
  reducers: {
    addAnnouncementModals: (state, action) => {
      if (!state.modals.find((m) => m.docId === action.payload.docId)) {
        state.modals.push(action.payload);
      }
    },
  },
  reducerPath: 'announcementModals',
});

export const { addAnnouncementModals } = announcementModalsSlice.actions;

export default announcementModalsSlice;
